import request from '@/config/axios'

export interface HomeBrandVO {
  id?: number
  name?: string
  picUrl?: string
}

export const getHomeBrand = async () => {
  return await request.get({ url: `/promotion/home-brand/get` })
}

export const saveHomeBrand = async (data: HomeBrandVO) => {
  return await request.put({ url: `/promotion/home-brand/save`, data })
}
